import moment from "moment";
import React, { Component } from "react";
import "react-block-ui/style.css";
import { Nav, NavItem } from "react-bootstrap";
import Datetime from "react-datetime";
import { Link } from "react-router-dom";
import LoadingIndicator from "../Components/LoadingIndicator/LoadingIndicator";
import Flags from "../Deals/Flags";
import SRFlags from "../SeminarRegistrations/Flags";
import TCSFlags from "../TCS/Flags";
import ReportsService from "../utils/ReportsService";
import UsersService from "../utils/UsersService";

const Stat = props => {
  const { number, text, percentage, alert, warning, show_number } = props;
  let cname = "panel status panel-info";
  if (alert) cname = cname + " panel-danger";
  if (warning) cname = cname + " panel-warning";

  let heading_class = show_number
    ? "panel-heading"
    : "panel-heading panel-success-heading";
  const number_label = show_number ? `${number || 0}` : "";
  const percentage_label = percentage !== undefined ? `(${percentage}%)` : "";

  return (
    <div className="status-card" style={{ width: 225 }}>
      <div className={cname}>
        <div className={heading_class}>
          <h1 className="panel-title text-center">
            {number_label} {percentage_label}
          </h1>
        </div>
        <div className="panel-body text-center">
          <strong>{text}</strong>
        </div>
      </div>
    </div>
  );
};

const DealTable = props => (
  <table className="table table-bordered table-zebra">
    <thead>
      <tr>
        <th>Deal</th>
        <th>Contact</th>
        <th style={{ width: "90px", minWidth: "70px" }}>TCS Assigned</th>
        <th>Status</th>
        <th>Flags</th>
        {props.tab === "unconfirmed" && (
          <>
            <th>Follow Up</th>
            <th>Dead Deal Reason</th>
          </>
        )}
        {props.tab === "unpresented" && (
          <>
            <th>Follow Up</th>
            <th>Unpresented Reason</th>
          </>
        )}
      </tr>
    </thead>
    <tbody>
      {props.deals.map(deal => (
        <tr>
          <td>
            <Link
              to={`/m1/deals/${deal.id}`}
              style={{
                whiteSpace: "nowrap"
              }}
            >
              Deal #{deal.id}
            </Link>
          </td>
          <td>
            <Link to={`/m1/contacts/${deal.contact_id}`}>
              {deal.contact_email}
            </Link>
          </td>
          <td>{deal.tcs_assigned_to && <div>{deal.tcs_assigned_to}</div>}</td>
          <td>
            <div>{deal.reasons[props.tab]}</div>
            {deal.descriptions[props.tab] && (
              <div>
                <small>{deal.descriptions[props.tab]}</small>
              </div>
            )}
          </td>
          <td>
            <SRFlags deal={deal} prefix="Registration: " />
            <TCSFlags deal={deal} prefix="TCS: " />
            <Flags deal={deal} prefix="Deal: " />
          </td>

          {props.tab === "unpresented" && (
            <>
              <td>
                {deal.lead_ids.map((lead_id, index) => (
                  <Link key={lead_id} to={`/m1/follow_ups/${lead_id}`}>
                    {lead_id}
                    {index < deal.lead_ids.length - 1 && ", "}
                  </Link>
                ))}
              </td>

              <td>
                {deal.reasons["tcs_not_presented"]
                  ? deal.reasons["tcs_not_presented"]
                      .split("_")
                      .map(word => word[0].toUpperCase() + word.slice(1))
                      .join(" ")
                  : ""}
              </td>
            </>
          )}
          {props.tab === "unconfirmed" && (
            <>
              <td>
                {deal.lead_ids.map((lead_id, index) => (
                  <Link key={lead_id} to={`/m1/follow_ups/${lead_id}`}>
                    {lead_id}
                    {index < deal.lead_ids.length - 1 && ", "}
                  </Link>
                ))}
              </td>

              <td>
                {deal.reasons["dead_deal"]
                  ? deal.reasons["dead_deal"]
                      .split("_")
                      .map(word => word[0].toUpperCase() + word.slice(1))
                      .join(" ")
                  : ""}
              </td>
            </>
          )}
        </tr>
      ))}
    </tbody>
  </table>
);

class ReportingTCSReasons extends Component {
  constructor(props) {
    super(props);
    const defaultFilter = {
      completed: "true",
      sale_made_by: "",
      tcs_assigned_to: "",
      region: "",
      date_field: "created_at",
      start_date: moment()
        .subtract(1, "day")
        .format("DD MMM YYYY"),
      end_date: moment()
        .subtract(1, "day")
        .format("DD MMM YYYY")
    };
    this.state = {
      filter: defaultFilter,
      data: null,
      coaches: [],
      currentPage: 1,
      totalPages: 1,
      per: 50,
      view: props.view,
      activeTab: "scheduled"
    };

    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.dateFilterChanged = this.dateFilterChanged.bind(this);
  }

  componentDidMount() {
    this.setState({ loadingInProgress: true }, () => {
      this.fetchItems();
      this.fetchCoaches();
      this.fetchVenues();
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.view !== prevProps.view) {
      const filter = {
        view: this.props.view,
        completed: "true",
        sale_made_by: "",
        tcs_assigned_to: "",
        region: "",
        date_field: "created_at",
        start_date: moment()
          .subtract(1, "day")
          .format("DD MMM YYYY"),
        end_date: moment()
          .subtract(1, "day")
          .format("DD MMM YYYY")
      };
      this.setState({ filter: filter, currentPage: 1 }, this.fetchItems);
    }
  }

  handleFilterChange(event) {
    let filter = { ...this.state.filter };
    filter[event.target.id] = event.target.value;
    this.setState({ filter: filter }, this.fetchItems);
  }

  dateFilterChanged(field, value) {
    let filter = { ...this.state.filter };
    filter[field] = value.format("DD MMM YYYY");
    this.setState({ filter: filter, currentPage: 1 }, this.fetchItems);
  }

  fetchItems() {
    this.setState({ loadingInProgress: true });
    ReportsService.tcsReasons({
      filter: this.state.filter,
      page: this.state.currentPage,
      per: this.state.per
    }).then(data => {
      this.setState({ loadingInProgress: false, data: data });
    });
  }

  fetchCoaches = () => {
    UsersService.allUsers().then(data => {
      this.setState({
        coaches: data
          .filter(c => c.roles.includes("tcs_coach"))
          .sort((a, b) => (a.name > b.name ? 1 : -1))
      });
    });
  };

  fetchVenues = () => {
    ReportsService.venues().then(data => {
      this.setState({ venues: data });
    });
  };

  handleSelectTab = tab => {
    this.setState({ activeTab: tab }, () => {});
  };

  render() {
    if (!this.state.data || !this.state.coaches || !this.state.venues)
      return null;
    const { data } = this.state;

    return (
      <LoadingIndicator loadingInProgress={this.state.loadingInProgress}>
        <div>
          <div style={{ marginBottom: "10px" }}>
            <div style={{ display: "inline-block", marginRight: 10 }}>
              <select
                id="sale_made_by"
                value={this.state.filter.sale_made_by}
                onChange={this.handleFilterChange}
              >
                <option value="">(sale made by - any)</option>
                {this.state.coaches.map(coach => (
                  <option key={coach.email} value={coach.email}>
                    {coach.name}
                  </option>
                ))}
              </select>
            </div>

            <div style={{ display: "inline-block", marginRight: 10 }}>
              <select
                id="tcs_assigned_to"
                value={this.state.filter.tcs_assigned_to}
                onChange={this.handleFilterChange}
              >
                <option value="">(tcs assigned to - any)</option>
                {this.state.coaches.map(coach => (
                  <option key={coach.email} value={coach.email}>
                    {coach.name}
                  </option>
                ))}
              </select>
            </div>

            <div style={{ display: "inline-block", marginRight: 10 }}>
              <select
                id="region"
                value={this.state.filter.region}
                onChange={this.handleFilterChange}
              >
                <option value="">(any region)</option>
                <option value="ACT">Australian Capital Territory (SSC)</option>
                <option value="NSW">New South Wales (HSC)</option>
                <option value="NT">Northern Territory (NTCET)</option>
                <option value="QLD">Queensland (QCE)</option>
                <option value="SA">South Australia (SACE)</option>
                <option value="TAS">Tasmania (TCE)</option>
                <option value="VIC">Victoria (VCE)</option>
                <option value="WA">Western Australia (WACE)</option>
              </select>
            </div>

            <div style={{ display: "inline-block", marginRight: 10 }}>
              <select
                id="venue"
                value={this.state.filter.venue}
                onChange={this.handleFilterChange}
              >
                <option value="">(any venue)</option>
                {this.state.venues.map(v => (
                  <option key={v} value={v}>
                    {v}
                  </option>
                ))}
              </select>
            </div>

            <div style={{ display: "inline-block", marginRight: 10 }}>
              <select
                id="business_stream"
                value={this.state.filter.business_stream}
                onChange={this.handleFilterChange}
              >
                <option value="">(any business stream)</option>
                <option value="seminar">Seminar</option>
                <option value="web">Web Booking</option>
                <option value="webinar">Webinar</option>
                <option value="callcentre">Call Centre</option>
                <option value="work_experience_directory">
                  Work Experience Directory
                </option>
                <option value="free_report">Free Report</option>
                <option value="seminar_confirmation_call">
                  Seminar Confirmation Call
                </option>
                <option value="seminar_no_show">Seminar No Show Call</option>
                <option value="seminar_attended_didnt_book">
                  Seminar Attended But Didnt Book
                </option>
                <option value="referral">Referral</option>
                <option value="other">Other</option>
              </select>
            </div>

            <div style={{ display: "inline-block", marginRight: 10 }}>
              <select
                id="booking_from"
                value={this.state.filter.booking_from}
                onChange={this.handleFilterChange}
              >
                <option value="">(any booking source)</option>
                <option value="seminar">Seminar</option>
                <option value="web">Web</option>
                <option value="call_centre">Call Centre</option>
                <option value="m1office">M1 Office</option>
              </select>
            </div>

            <div
              style={{
                display: "inline-block",
                marginRight: 10,
                marginTop: 12
              }}
            >
              <select
                id="completed"
                value={this.state.filter.completed}
                onChange={this.handleFilterChange}
              >
                <option value="true">Only Completed Deals</option>
                <option value="ignore">Ignore Completed Status</option>
              </select>
            </div>
          </div>
          <div>
            <div style={{ display: "inline-block", marginRight: 10 }}>
              <Datetime
                inputProps={{ className: "" }}
                onChange={v => this.dateFilterChanged("start_date", v)}
                value={this.state.filter.start_date}
                closeOnSelect={true}
                dateFormat="DD MMM YYYY"
                timeFormat={false}
              />
            </div>

            <div style={{ display: "inline-block", marginRight: 10 }}>
              <Datetime
                inputProps={{ className: "" }}
                onChange={v => this.dateFilterChanged("end_date", v)}
                value={this.state.filter.end_date}
                closeOnSelect={true}
                dateFormat="DD MMM YYYY"
                timeFormat={false}
              />
            </div>
            <div style={{ display: "inline-block", marginRight: 10 }}>
              <select
                id="date_field"
                value={this.state.filter.date_field}
                onChange={this.handleFilterChange}
              >
                <option value="tcs_at">TCS At</option>
              </select>
            </div>
          </div>
        </div>
        <div>
          <h3>TCS Results and Reasons</h3>
          <div className="row">
            <div className="col-md-6">
              <Stat
                number={data.stats.scheduled}
                text="Scheduled"
                show_number={true}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <div className="clearfix">
                <Stat
                  number={data.stats.confirmed}
                  text="Confirmed"
                  percentage={data.percentages.confirmed_to_scheduled}
                  show_number={true}
                />
              </div>
              <div className="clearfix">
                <Stat
                  number={data.stats.presented}
                  text="Presented"
                  percentage={data.percentages.presented_to_confirmed}
                  show_number={true}
                />
              </div>
              <div className="clearfix">
                <Stat
                  number={data.stats.sales}
                  text="Sales"
                  percentage={data.percentages.sales_to_presented}
                  show_number={true}
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="clearfix">
                <Stat
                  number={data.stats.scheduled - data.stats.confirmed}
                  text="Unconfirmed"
                  percentage={data.percentages.unconfirmed_to_scheduled}
                  show_number={true}
                />
              </div>
              <div className="clearfix">
                <Stat
                  number={data.stats.confirmed - data.stats.presented}
                  text="Unpresented"
                  percentage={data.percentages.unpresented_to_confirmed}
                  show_number={true}
                />
              </div>
              <div className="clearfix">
                <Stat
                  number={data.stats.presented - data.stats.sales}
                  text="Unsold"
                  percentage={data.percentages.unsold_to_presented}
                  show_number={true}
                />
              </div>
              <div className="clearfix">
                <Stat
                  number={data.stats.cancelled}
                  text="Cancelled Sale"
                  percentage={data.percentages.cancelled_to_presented}
                  show_number={true}
                  alert={true}
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="clearfix">
                <Stat
                  number={data.stats.rescheduled}
                  text="Rescheduled"
                  percentage={data.percentages.rescheduled_to_scheduled}
                  show_number={true}
                />
              </div>
              <div className="clearfix">
                <Stat
                  number={data.stats.presented}
                  text="Presented : Scheduled"
                  percentage={data.percentages.presented_to_scheduled}
                  show_number={false}
                />
              </div>
              <div className="clearfix">
                <Stat
                  number={data.stats.sales}
                  text="Sold : Scheduled"
                  percentage={data.percentages.sales_to_scheduled}
                  show_number={false}
                />
              </div>
            </div>
          </div>
        </div>

        <h3>Matching Deals</h3>

        <Nav
          bsStyle="tabs"
          activeKey={this.state.activeTab}
          onSelect={this.handleSelectTab.bind(this)}
        >
          <NavItem eventKey="scheduled">Scheduled</NavItem>
          <NavItem eventKey="confirmed">Confirmed</NavItem>
          <NavItem eventKey="unconfirmed">Unconfirmed</NavItem>
          <NavItem eventKey="presented">Presented</NavItem>
          <NavItem eventKey="unpresented">Unpresented</NavItem>
          <NavItem eventKey="sales">Sales</NavItem>
          <NavItem eventKey="cancelled">Cancelled Sale</NavItem>
          <NavItem eventKey="unsold">Unsold</NavItem>
        </Nav>
        <div className="tab-content">
          {this.state.activeTab === "scheduled" && (
            <DealTable deals={data.deals} tab={this.state.activeTab} />
          )}
          {this.state.activeTab === "confirmed" && (
            <DealTable
              deals={data.deals.filter(d =>
                d.flags.includes("tcs_attendee_confirmed")
              )}
              tab={this.state.activeTab}
            />
          )}
          {this.state.activeTab === "unconfirmed" && (
            <DealTable
              deals={data.deals.filter(
                d => !d.flags.includes("tcs_attendee_confirmed")
              )}
              tab={this.state.activeTab}
            />
          )}
          {this.state.activeTab === "presented" && (
            <DealTable
              deals={data.deals.filter(
                d =>
                  d.flags.includes("tcs_attendee_confirmed") &&
                  d.flags.includes("tcs_presented")
              )}
              tab={this.state.activeTab}
            />
          )}
          {this.state.activeTab === "unpresented" && (
            <DealTable
              deals={data.deals.filter(
                d =>
                  d.flags.includes("tcs_attendee_confirmed") &&
                  !d.flags.includes("tcs_presented")
              )}
              tab={this.state.activeTab}
            />
          )}
          {this.state.activeTab === "sales" && (
            <DealTable
              deals={data.deals.filter(
                d =>
                  d.flags.includes("tcs_attendee_confirmed") &&
                  d.flags.includes("tcs_presented") &&
                  d.flags.includes("sale_made")
              )}
              tab={this.state.activeTab}
            />
          )}
          {this.state.activeTab === "cancelled" && (
            <DealTable
              deals={data.deals.filter(d => d.flags.includes("tcs_cancelled"))}
              tab={this.state.activeTab}
            />
          )}
          {this.state.activeTab === "unsold" && (
            <DealTable
              deals={data.deals.filter(
                d =>
                  d.flags.includes("tcs_attendee_confirmed") &&
                  d.flags.includes("tcs_presented") &&
                  !d.flags.includes("sale_made")
              )}
              tab={this.state.activeTab}
            />
          )}
        </div>
      </LoadingIndicator>
    );
  }
}
export default ReportingTCSReasons;
